// authActions.js

export const LOGGED_IN = 'LOGGED_IN';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGGED_OUT = 'LOGGED_OUT';

/**
 * Action to handle login success
 * @param {object} authData - The login payload (can include tokens, user info, etc.)
 * @returns {object} Redux action
 */
export const loggedIn = (authData) => ({
  type: LOGGED_IN,
  payload: authData, // stored entirely in authState
});

/**
 * Action to handle login failure
 * @param {string} error - Error message
 * @returns {object} Redux action
 */
export const loginFailure = (error) => ({
  type: LOGIN_FAILURE,
  payload: error,
});

/**
 * Action to handle logout
 * @returns {object} Redux action
 */
export const loggedOut = () => ({
  type: LOGGED_OUT,
});
